module.exports = __webpack_public_path__ + "static/media/bigfoot_ranking_app.d27bb544.md";